import React, { useEffect, useRef, useState } from 'react'
import './projectsPage.css'
import HorizontalNavBar from '../CustomComponents/HorizontalNavBar/HorizontalNavBar'
import useGetItems from '../../fetches/useGetItems.js'
import ProjectsList from '../ProjectsList/ProjectsList.jsx'
import Search from '../CustomComponents/Search/Search.jsx'
import Footer from '../CustomComponents/Footer/Footer.jsx'
import DropDownList from '../CustomComponents/DropDownList/DropDownList.jsx'
import Modal from '../Modal/Modal'
import { ProjectGallery } from '../CardProject/CardProject'

const ProjectsPage = () => {
    const childRef = useRef();
    const { data, loading, error } = useGetItems("https://arhmiplan.site/api/projects");

    const originalData = data;

    const [filteredProjects, setFilteredProjects] = useState(data);
    const [selectedProject, setSelectedProject] = useState();

    useEffect(() => {
        setFilteredProjects(data);
    }, [data])

    const filterData = (criteria) => {
        setFilteredProjects(criteria);
    };

    const handleClickChildButton = () => {
        if (childRef.current) {
            childRef.current.closeDropdown();
        }
    };

    const handleProjectClick = (projectDetails) => {
        if (!projectDetails) return;
        const selectProject ={
            name: projectDetails.name,
            text: projectDetails.description,
            type: projectDetails.type,
            year: projectDetails.year,
            images: projectDetails.images
        }
        
        setSelectedProject(selectProject)
    }

    const closeProjectModal = () => setSelectedProject(null)

    return (
        <>
            <div className='projects_page_block' onClick={handleClickChildButton}>
                <div className="content_projects_page">
                    <HorizontalNavBar />

                    <div className="filters">
                        <div className="filters_content">
                            <div className="search_bloc">
                                <Search data={data} onFilter={filterData} startData={originalData} />
                            </div>
                            
                            <div className="type_project_dropdown">
                                <DropDownList data={data} onFilter={filterData} startData={originalData} ref={childRef} />
                            </div>
                        </div>
                    </div>

                    <ProjectsList data={filteredProjects} onProjectClick={handleProjectClick} />

                </div>

                <Footer />
            </div>

            <Modal
                isOpen={Boolean(selectedProject)}
                onClose={closeProjectModal}
                title={selectedProject?.name}
                size="lg"
            >
                {
                    selectedProject ? (
                        <div className="project-modal">
                            {
                                selectedProject.images?.length ? (
                                    <ProjectGallery images={selectedProject.images} title={selectedProject.name} />
                                ) : null}
                            
                            {/* <div className="project-modal__meta">
                                {selectedProject.year ? <span>{selectedProject.year}</span> : null}
                                {selectedProject.year && selectedProject.location ? <span>•</span> : null}
                                {selectedProject.location ? <span>{selectedProject.location}</span> : null}
                            </div> */}
                            <p className="project-modal__description">{selectedProject.text}</p>
                        </div>
                    ) : null}
            </Modal>


        </>
    )
}

export default ProjectsPage